(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3813],{

/***/ 92536:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CustomMetaHead; }
/* harmony export */ });
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);



function CustomMetaHead(_ref) {
  var children = _ref.children,
      meta = _ref.meta;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_0___default()), {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("title", {
      children: [meta.title, " | ", "SUPERMARKET Κρητικός"]
    }), children, /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "description",
      content: meta.description
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "keywords",
      content: meta.keywords
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "robots",
      content: "index, follow"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      property: "og:title",
      content: "".concat(meta.title, " | ").concat("SUPERMARKET Κρητικός")
    }, "title"), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      property: "og:url",
      content: meta.url
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      property: "og:image",
      content: meta.image
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      property: "og:image:width",
      content: "1080"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      property: "og:image:height",
      content: "1080"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      property: "og:image:alt",
      content: meta.alt
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      property: "og:description",
      content: meta.description
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      property: "og:site_name",
      content: meta.alt
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      property: "og:type",
      content: "website"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
      rel: "canonical",
      content: meta.url
    })]
  });
}

/***/ }),

/***/ 94892:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Stores; }
});

// EXTERNAL MODULE: ./styles/pages/index.module.scss
var index_module = __webpack_require__(28833);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./src/components/CustomMetaHead.jsx
var CustomMetaHead = __webpack_require__(92536);
// EXTERNAL MODULE: ./src/components/Footer/Footer.jsx + 5 modules
var Footer = __webpack_require__(31875);
// EXTERNAL MODULE: ./src/components/Header/Header.jsx + 8 modules
var Header = __webpack_require__(3266);
// EXTERNAL MODULE: ./src/components/Navigation/Navigation.jsx
var Navigation = __webpack_require__(86894);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/google-maps-react/dist/index.js
var dist = __webpack_require__(95642);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./src/utils/googleAPIKey.js
var googleAPIKey = __webpack_require__(21694);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/MapContainer/MapContainerStores.jsx




var style = {
  width: '100%',
  height: '27.25rem'
};
var containerStyle = {
  position: 'relative',
  maxWidth: '100%',
  height: '100%'
};

function MapContainer(_ref) {
  var google = _ref.google,
      stores = _ref.stores,
      store = _ref.store;
  var storeLat = get_default()(store, 'fields.coordinates[1]', 37.9852805);
  var storeLng = get_default()(store, 'fields.coordinates[0]', 23.7519884);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(dist.Map, {
    style: style,
    containerStyle: containerStyle,
    google: google,
    zoom: 14,
    initialCenter: {
      lat: 37.9852805,
      lng: 23.7519884
    },
    center: {
      lat: storeLat,
      lng: storeLng
    },
    children: stores.map(function (s) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(dist.Marker, {
        position: {
          lat: s.fields.coordinates[1],
          lng: s.fields.coordinates[0]
        },
        icon: {
          url: "/assets/".concat("kritikos", "/brandPin.png"),
          anchor: new google.maps.Point(24, 32),
          scaledSize: new google.maps.Size(24, 32)
        }
      }, s.uuid);
    })
  });
}

/* harmony default export */ var MapContainerStores = ((0,dist.GoogleApiWrapper)({
  apiKey: googleAPIKey/* default */.Z,
  language: 'el'
})(MapContainer));
// EXTERNAL MODULE: ./node_modules/react-accessible-accordion/dist/es/index.js
var es = __webpack_require__(11876);
// EXTERNAL MODULE: ./src/components/StoresPage/StoresAccordion.module.scss
var StoresAccordion_module = __webpack_require__(35210);
var StoresAccordion_module_default = /*#__PURE__*/__webpack_require__.n(StoresAccordion_module);
;// CONCATENATED MODULE: ./src/components/StoresPage/StoresAccordion.jsx







function StoresAccordion(_ref) {
  var stores = _ref.stores,
      regions = _ref.regions,
      setStore = _ref.setStore;

  var _useState = (0,react.useState)(''),
      regionStores = _useState[0],
      setRegionStores = _useState[1];

  var _useState2 = (0,react.useState)(),
      currRegions = _useState2[0],
      setCurrRegions = _useState2[1];

  function sortRegionStore(regionStore) {
    return regionStore.sort(function (a, b) {
      if (a.title < b.title) return -1;
      if (a.title > b.title) return 1;
      return 0;
    });
  }

  (0,react.useEffect)(function () {
    var _regionStores = regions.map(function (region) {
      var storeUUIDs = get_default()(region, 'fields.stores');
      if (!storeUUIDs) return null;
      return storeUUIDs.flatMap(function (uuid) {
        return stores.filter(function (s) {
          return s.uuid === uuid;
        });
      });
    });

    _regionStores.flatMap(function (s) {
      return sortRegionStore(s);
    });

    setRegionStores(_regionStores);
    setCurrRegions(regions);
  }, []);
  if (!regionStores || !currRegions) return null;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(es/* Accordion */.UQ, {
      children: currRegions.map(function (region, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsxs)(es/* AccordionItem */.Qd, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(es/* AccordionItemHeading */.Ol, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(es/* AccordionItemButton */.on, {
              className: (StoresAccordion_module_default()).accordionBtn,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                className: (StoresAccordion_module_default()).btn,
                id: index,
                children: "\u039D\u039F\u039C\u039F\u03A3 ".concat(region.title)
              })
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(es/* AccordionItemPanel */.Mt, {
            className: (StoresAccordion_module_default()).accordionPanel,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(es/* Accordion */.UQ, {
              children: regionStores[index].map(function (s) {
                return /*#__PURE__*/(0,jsx_runtime.jsxs)(es/* AccordionItem */.Qd, {
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(es/* AccordionItemHeading */.Ol, {
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(es/* AccordionItemButton */.on, {
                      className: (StoresAccordion_module_default()).accordionInnerBtn,
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                        className: (StoresAccordion_module_default()).innerBtn,
                        id: index,
                        onClick: function onClick() {
                          return setStore(s);
                        },
                        children: "\u039A\u03B1\u03C4\u03AC\u03C3\u03C4\u03B7\u03BC\u03B1 ".concat(s.title)
                      })
                    })
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)(es/* AccordionItemPanel */.Mt, {
                    className: (StoresAccordion_module_default()).accordionInnerPanel,
                    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                      className: (StoresAccordion_module_default()).text,
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                        className: (StoresAccordion_module_default()).storeTitle,
                        children: "\u0394\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7:"
                      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                        className: (StoresAccordion_module_default()).storeDetails,
                        children: [" ", s.fields.address]
                      })]
                    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                      className: (StoresAccordion_module_default()).text,
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                        className: (StoresAccordion_module_default()).storeTitle,
                        children: "\u03A4\u03B7\u03BB\u03AD\u03C6\u03C9\u03BD\u03BF:"
                      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                        className: (StoresAccordion_module_default()).storeDetails,
                        children: [" ", s.fields.phone]
                      })]
                    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                      className: (StoresAccordion_module_default()).text,
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                        className: (StoresAccordion_module_default()).storeTitle,
                        children: "\u03A9\u03C1\u03AC\u03C1\u03B9\u03BF:"
                      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                        className: (StoresAccordion_module_default()).storeDetailsHours,
                        children: [" ", s.fields.work_hours]
                      })]
                    })]
                  })]
                }, s.uuid);
              })
            })
          })]
        }, region.uuid);
      })
    })
  });
}

/* harmony default export */ var StoresPage_StoresAccordion = (StoresAccordion);
// EXTERNAL MODULE: ./src/components/StoresPage/StoresLayout.module.scss
var StoresLayout_module = __webpack_require__(11078);
var StoresLayout_module_default = /*#__PURE__*/__webpack_require__.n(StoresLayout_module);
;// CONCATENATED MODULE: ./src/components/StoresPage/StoresLayout.jsx







function StoresLayout(_ref) {
  var stores = _ref.stores,
      regions = _ref.regions;

  var _useState = (0,react.useState)(),
      store = _useState[0],
      setStore = _useState[1];

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
    className: (StoresLayout_module_default()).section,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: classnames_default()((StoresLayout_module_default()).column, (StoresLayout_module_default()).map),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(MapContainerStores, {
        stores: stores,
        store: store
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (StoresLayout_module_default()).column,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(StoresPage_StoresAccordion, {
        stores: stores,
        regions: regions,
        setStore: setStore
      })
    })]
  });
}
;// CONCATENATED MODULE: ./src/pages/stores.jsx









var __N_SSG = true;
function Stores(_ref) {
  var footerLinks = _ref.footerLinks,
      navigation = _ref.navigation,
      stores = _ref.stores,
      regions = _ref.regions,
      meta = _ref.meta;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CustomMetaHead/* default */.Z, {
      meta: meta
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("header", {
      className: (index_module_default()).headerContainer,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Header/* default */.Z, {
        navigation: navigation
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Navigation/* default */.Z, {
        navigation: navigation
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(StoresLayout, {
      stores: stores,
      regions: regions
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {
      footerLinks: footerLinks
    })]
  });
}

/***/ }),

/***/ 21694:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var GOOGLE_API_KEY = 'AIzaSyDpHdNA79ZQFvlwDYBeoHgT_AFsvIux3JE';
/* harmony default export */ __webpack_exports__["Z"] = (GOOGLE_API_KEY);

/***/ }),

/***/ 43486:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stores",
      function () {
        return __webpack_require__(94892);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 35210:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"accordionBtn":"StoresAccordion_accordionBtn__ARPsW","accordionPanel":"StoresAccordion_accordionPanel__aCgql","fadein":"StoresAccordion_fadein__eXR_z","accordionInnerBtn":"StoresAccordion_accordionInnerBtn__TbkH5","accordionInnerPanel":"StoresAccordion_accordionInnerPanel__lBj_q","storeTitle":"StoresAccordion_storeTitle__MSvuY","storeDetails":"StoresAccordion_storeDetails__zRUKf","storeDetailsHours":"StoresAccordion_storeDetailsHours__nNr1p","text":"StoresAccordion_text__RfyRv","button":"StoresAccordion_button__pto5M","btn":"StoresAccordion_btn__zcxOQ","innerBtn":"StoresAccordion_innerBtn__Gsa8e"};

/***/ }),

/***/ 11078:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section":"StoresLayout_section__Ch8XV","column":"StoresLayout_column__GjrRm","question":"StoresLayout_question__h11tr","content":"StoresLayout_content__SmlIY","map":"StoresLayout_map__Q7bGj"};

/***/ }),

/***/ 28833:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"index_headerContainer__J9svF"};

/***/ }),

/***/ 92703:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(50414);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 45697:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(92703)();
}


/***/ }),

/***/ 50414:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,5937,9866,1228,4617,5445,3609,3996,4843,5642,1876,9950,2888,179], function() { return __webpack_exec__(16395), __webpack_exec__(43486); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);